import { render, staticRenderFns } from "./caseCenterDetail.vue?vue&type=template&id=3ee1aa23&scoped=true&"
import script from "./caseCenterDetail.vue?vue&type=script&lang=js&"
export * from "./caseCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./caseCenterDetail.vue?vue&type=style&index=0&id=3ee1aa23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1aa23",
  null
  
)

export default component.exports